import React, { useState } from 'react';
import InteractiveRenderer from '../components/interactive/InteractiveRenderer';

const scenarios = {
  DistributionSlider: {
    type: 'interactive',
    component: 'DistributionSlider',
    config: { mean: 0, stdDev: 1, kurtosis: 2 }
  },
  DragAndDropMatch: {
    type: 'interactive',
    component: 'DragAndDropMatch',
    config: {
      prompt: 'Match the financial terms with their correct definitions:',
      pairs: [
        { id: 1, term: 'Beta', match: 'Measure of systematic risk' },
        { id: 2, term: 'Alpha', match: 'Excess return over benchmark' },
        { id: 3, term: 'Sharpe Ratio', match: 'Return per unit of risk' },
        { id: 4, term: 'Duration', match: 'Interest rate sensitivity' }
      ]
    }
  },
  FormulaBuilderDragDrop: {
    type: 'interactive',
    component: 'FormulaBuilderDragDrop',
    config: {
      prompt: 'Build the NPV formula',
      pieces: ['∑', '(', 'FRACTION', ')', '-', 'Initial Investment'],
      answerSequence: ['∑', '(', 'FRACTION', ')', '-', 'Initial Investment']
    }
  }
};

export default function InteractivePlaygroundPage() {
  const [selectedKey, setSelectedKey] = useState('DistributionSlider');
  const qaItem = scenarios[selectedKey];

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <h1 className="text-2xl font-bold mb-4 text-indigo-700">🧪 Interactive Playground</h1>

      <div className="mb-6">
        <label className="block mb-1 text-sm font-medium text-gray-700">Choose Scenario:</label>
        <select
          className="p-2 border rounded bg-white"
          value={selectedKey}
          onChange={(e) => setSelectedKey(e.target.value)}
        >
          {Object.keys(scenarios).map((key) => (
            <option key={key} value={key}>{key}</option>
          ))}
        </select>
      </div>

      <InteractiveRenderer component={qaItem.component} config={qaItem.config} />
    </div>
  );
}